import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
const Crausal_home = () => {
  return (
    <Carousel>
      <div>
        <img
          style={{ width: "350px" }}
          src="https://cdn.caratlane.com/media/catalog/product/cache/6/image/480x480/9df78eab33525d08d6e5fb8d27136e95/J/S/JS00811-1YP900_11_listfront.jpg"
        />
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Price: 42,105
        </p>
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          GOLD MANGALSUTRA
        </p>
      </div>
      <div>
        <img
          style={{ width: "350px" }}
          src="https://cdn.caratlane.com/media/catalog/product/cache/6/image/480x480/9df78eab33525d08d6e5fb8d27136e95/U/G/UG00021-1Y0000_11_listfront.jpg"
        />
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Price: 5,465
        </p>
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Exclusive evil eye gold
        </p>
      </div>
      <div>
        <img
          style={{ width: "350px" }}
          src="https://cdn.caratlane.com/media/catalog/product/cache/6/image/480x480/9df78eab33525d08d6e5fb8d27136e95/J/R/JR03769-YGP900_11_listfront.jpg"
        />
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Price: 20,465
        </p>
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          INTERWIND DIMOND BRACELET
        </p>
      </div>
      <div>
        <img
          style={{ width: "350px" }}
          src="https://cdn.caratlane.com/media/catalog/product/cache/6/image/480x480/9df78eab33525d08d6e5fb8d27136e95/U/T/UT00685-1Y0000_11_listfront.jpg"
        />
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Price: 7,405
        </p>
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          STELLER LUMINUS CHAIN
        </p>
      </div>
      <div>
        <img
          style={{ width: "350px" }}
          src="https://cdn.caratlane.com/media/catalog/product/cache/6/image/480x480/9df78eab33525d08d6e5fb8d27136e95/U/E/UE00004-YG0000_11_listfront.jpg"
        />
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Price: 10,601
        </p>
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          DROP GOLD
        </p>
      </div>
      <div>
        <img
          style={{ width: "350px" }}
          src="https://cdn.caratlane.com/media/catalog/product/cache/6/image/480x480/9df78eab33525d08d6e5fb8d27136e95/U/G/UG00021-1Y0000_11_listfront.jpg"
        />
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Price: 5,465
        </p>
        <p
          style={{
            margin: "auto",
            marginTop: "25px",
            width: "30%",
            fontSize: "30px",
          }}
        >
          Exclusive evil eye gold
        </p>
      </div>
    </Carousel>
  );
};

export default Crausal_home;
